// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{min-height:100vh;--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity));scroll-behavior:smooth}body.noscroll{overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
